import * as http from "@/utils/request";
import { CategoryTab } from "@/interfaces/nftTypes";
import { RFResponse, RFResponseCommon } from "@/interfaces/common";
const baseUrl = process.env.NEXT_PUBLIC_BASE_API;
export const getCategories = async () => {
  const url = "http://10.131.18.44:30700/mock/31" + "/nft/avatar/categories";
  return http.get(url);
};

/**
 *  获取封面Tabs
 */
export const getCoverCategories = async () => {
  const url = `${baseUrl}/watchlist/api/nft/covers/lists`;
  try {
    const { code, data } = await http.get<RFResponse<CategoryTab[]>>(url);
    if (code === 200) {
      return data;
    }
    return [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

/**
 * 喜欢封面
 */

export const likeCover = async (coverId: string) => {
  const url = `${baseUrl}/watchlist/api/nft/covers/desire/${coverId}`;
  try {
    const { code } = await http.post<null, RFResponseCommon<null>>(url);
    return code == 200;
  } catch (error) {
    return false;
  }
};

/**
 * 取消喜欢封面
 */
export const unlikeCover = async (coverId: string) => {
  const url = `${baseUrl}/watchlist/api/nft/covers/desire/${coverId}`;
  try {
    const { code } = await http._delete<RFResponseCommon<null>>(url);
    return code == 200;
  } catch (error) {
    return false;
  }
};
